import React from 'react';
export function ProviderIcon({ provider, size = 21 }) {
  const props = { width: size, height: size, viewBox: '0 0 24 24', 'aria-hidden': true, focusable: 'false' };
  if (provider === 'google')
    return <svg {...props}>
      <path fill="#4285F4" d="M21.6 12.23c0-.7-.06-1.36-.18-2H12v3.78h5.38a4.6 4.6 0 0 1-2 3.02v2.47h3.24c1.9-1.75 2.98-4.33 2.98-7.27Z" />
      <path fill="#34A853" d="M12 22c2.7 0 4.97-.9 6.62-2.5l-3.24-2.47c-.9.6-2.04.97-3.38.97-2.6 0-4.8-1.75-5.59-4.1H3.08v2.55A10 10 0 0 0 12 22Z" />
      <path fill="#FBBC05" d="M6.41 13.9a6.03 6.03 0 0 1 0-3.8V7.55H3.08a10 10 0 0 0 0 8.9l3.33-2.55Z" />
      <path fill="#EA4335" d="M12 6c1.47 0 2.8.51 3.84 1.52l2.88-2.88A9.57 9.57 0 0 0 12 2a10 10 0 0 0-8.92 5.55l3.33 2.55C7.2 7.75 9.4 6 12 6Z" />
    </svg>;
  if (provider === 'linkedin')
    return <svg {...props}>
      <rect width="22" height="22" x="1" y="1" rx="4" fill="#0A66C2" />
      <path fill="white" d="M6.4 9h2.3v8H6.4V9Zm1.15-3.4a1.34 1.34 0 1 1 0 2.68 1.34 1.34 0 0 1 0-2.68ZM10.1 9h2.2v1.1c.32-.6 1.1-1.25 2.28-1.25 2.45 0 2.92 1.6 2.92 3.65V17h-2.3v-4c0-.95-.02-2.16-1.3-2.16-1.31 0-1.5 1.02-1.5 2.1V17h-2.3V9Z" />
    </svg>;
  if (provider === 'apple')
    return <svg {...props} viewBox="0 0 24 24">
      <path fill="currentColor" d="M17.3 12.7c.02 2.3 2 3.06 2.02 3.07-.02.05-.32 1.1-1.04 2.18-.62.94-1.26 1.87-2.27 1.9-.99.02-1.3-.6-2.43-.6-1.12 0-1.47.58-2.4.62-.98.04-1.73-1.01-2.36-1.95-1.28-1.88-2.26-5.3-.94-7.6a3.63 3.63 0 0 1 3.08-1.87c.96-.02 1.86.67 2.45.67.59 0 1.69-.83 2.85-.71.49.02 1.88.2 2.77 1.5-.07.05-1.66.98-1.64 2.79ZM15.5 6.9a4.2 4.2 0 0 0 .98-3.05 4.2 4.2 0 0 0-2.72 1.45 4.04 4.04 0 0 0-1.01 2.95 3.5 3.5 0 0 0 2.75-1.35Z" />
    </svg>;
  return <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="8" cy="12" r="4" />
    <path d="M12 12h10m-4 0v4m-3-4v3" />
  </svg>;
}
export function ProviderButton({ provider, children, ...props }) {
  return <button type="button" className="al-provider" {...props}>
    <span className="al-provider-icon">
      <ProviderIcon provider={provider} />
    </span>
    <span>
      {children}
    </span>
    <span className="al-provider-arrow" aria-hidden="true">
      →
    </span>
  </button>;
}
